import $ from 'cash-dom';
import smoothScroll from 'smoothscroll';

/**
 * Listens for click events on 'go-scroll-to' classes
 * @param {number} [offset=0] Offset of the scroll position
 * @param {number} [scrollTime=1200] Time of the scroll
 */
export default function registerScrollListener(offset, scrollTime) {
    offset = offset || 0;
    scrollTime = scrollTime == null ? 1200 : scrollTime;

    $('.go-scroll-to').on('click', function () {
        let sel = $(this).data('scroll-to');
        let sel$ = $(sel);
        if (sel && sel$.length) {
            smoothScroll($(sel).offset().top - offset, scrollTime);
        }
    });
}
